import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Alert } from './Alert';
import { logClientEvent } from '@/shared/lib/logging/clientLog';

interface Props {
  children: ReactNode;
  fallback?: (error: Error, reset: () => void) => ReactNode;
  onError?: (error: Error, info: ErrorInfo) => void;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };
  static getDerivedStateFromError(error: Error): State {
    return { error };
  }
  override componentDidCatch(error: Error, info: ErrorInfo) {
    /*
     * Çöken bileşen SUNUCUYA da bildirilir: ekranın hangi ağaçta ve hangi bileşende
     * patladığı yalnızca kullanıcının konsolunda kalıyordu. `componentStack` hatanın
     * yerini gösteren tek ipucu.
     */
    logClientEvent({
      source: 'boundary',
      level: 'fatal',
      kind: error.name,
      message: error.message || 'Bileşen çöktü',
      stack: [error.stack, info.componentStack].filter(Boolean).join('\n---\n'),
    });
    this.props.onError?.(error, info);
  }
  reset = () => this.setState({ error: null });
  override render() {
    if (this.state.error) {
      return this.props.fallback ? (
        this.props.fallback(this.state.error, this.reset)
      ) : (
        <div className="p-4">
          <Alert tone="danger">{this.state.error.message}</Alert>
        </div>
      );
    }
    return this.props.children;
  }
}
